import {
	baseApiHeaders,
	handleBucketSignedUpload,
	HIDE_TOAST_KEY,
	type IApiResponse,
	type IKybDetails,
	type IKybDocDetails,
	type IKybDocResponse,
	type IUploadPresignedDocArg,
	sanitizeKybReqData,
	type UploadErrorPayload,
} from 'BreetHelpers';

import { apiSlice } from './apiSlice';

export const kybApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		verifyKybIdentity: builder.mutation<IApiResponse<{ token: string }>, { email: string; otp?: string }>({
			query: ({ email, otp }) => ({
				method: 'POST',
				url: '/users/kyb/verify',
				body: { email, otp },
			}),
		}),
		submitKybDetails: builder.mutation<IApiResponse<IKybDetails>, Partial<IKybDetails>>({
			query: (data) => ({
				method: 'POST',
				url: '/users/kyb/submit',
				body: sanitizeKybReqData(data),
			}),
			invalidatesTags: ['GetKybDetails'],
		}),
		uploadKybDocs: builder.mutation<IApiResponse<IKybDocResponse[]>, { files: IKybDocDetails[] }>({
			query: (data) => ({
				method: 'PUT',
				url: '/users/kyb/upload',
				body: { ...data },
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
		}),
		uploadToPresignedUrl: builder.mutation<void, IUploadPresignedDocArg, UploadErrorPayload>({
			queryFn: handleBucketSignedUpload,
		}),

		getKybDetails: builder.query<IApiResponse<Partial<IKybDetails>>, void>({
			query: () => ({ url: '/users/kyb', headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' } }),
			providesTags: ['GetKybDetails'],
		}),

		updateKyb: builder.mutation<IApiResponse<IKybDocResponse[]>, { directorBvn: string; directorDob: string }>({
			query: (data) => ({
				method: 'PATCH',
				url: '/users/kyb/update',
				body: { ...data },
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['User'],
		}),
	}),
});

export const {
	useVerifyKybIdentityMutation,
	useGetKybDetailsQuery,
	useLazyGetKybDetailsQuery,
	useSubmitKybDetailsMutation,
	useUploadKybDocsMutation,
	useUploadToPresignedUrlMutation,
	useUpdateKybMutation,
} = kybApiSlice;

export const selectKybDetails = kybApiSlice.endpoints.getKybDetails.select();
